import { List, Record } from 'immutable'
import {
  ContactEmailAddress,
  IContactEmailAddress,
} from './ContactEmailAddress'
import { ShareContactType } from './enums'

export interface IShareContact {
  readonly name: string
  readonly id: string
  readonly type: ShareContactType
  readonly addresses: List<IContactEmailAddress>
}

const ShareContactRecord = Record({
  addresses: List<ContactEmailAddress>(),
  id: '',
  name: '',
  type: '',
})

export class ShareContact extends ShareContactRecord implements IShareContact {
  public static fromJS(initialState?: Partial<IShareContact>) {
    if (!initialState) {
      return new ShareContact()
    }

    const { addresses, ...rest } = initialState
    return new ShareContact({
      addresses: addresses
        ? List(addresses.map((r) => ContactEmailAddress.fromJS(r)))
        : List<ContactEmailAddress>(),
      ...rest,
    })
  }

  public readonly name: string
  public readonly id: string
  public readonly type: ShareContactType
  public readonly addresses: List<ContactEmailAddress>

  constructor(props?: Partial<ShareContact>) {
    props ? super(props) : super()
  }
}
